<div class="modal-header flex-shrink-0">
  <h4 class="modal-title">
    {{'shareProjectPopup.title' | translate}}
    <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate" ><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h4>
</div>
<div class="modal-body pt-0 d-flex flex-column" style="overflow-y: hidden">
  <div class="fixed-fluid flex-grow-1" style="height: 100%;">
    <div class="dialog-panel ps-0 fluid d-flex flex-column" style="height: 100%">
      <hr class="mt-0 w-100">
      <ol class="dialog-breadcrumb d-flex align-items-center">
        <app-svg-icon type="folder-user" size="medium-small" />&nbsp;<li class="d-inline">{{'shareProjectPopup.title' | translate}}</li>
        <ng-template ngFor let-projectGroup [ngForOf]="model.navigationChain" let-i="index">
          <li class="d-inline" [class.active]="i === (model.navigationChain.length - 1)">
            <a href="javascript:void(0)" (click)="navigateInChain(projectGroup)">{{
              i === 0 ? (projectGroup.groupName | translate) : projectGroup.groupName
              }}
            </a>
          </li>
        </ng-template>
      </ol>
      <!-- Suche -->
      <div class="dialog-search d-flex align-items-center gap-2 flex-shrink-0 flex-grow-0">
          <app-svg-icon (click)="performUndo()" [class.disabled]="!model.canUndo" type="arrow-left" size="medium-small" class="c-pointer"/>
          <app-svg-icon (click)="performRedo()" [class.disabled]="!model.canRedo" type="arrow-right" size="medium-small" class="c-pointer" />
        <div class="btn-group flex-grow-1 ms-3">
          <input type="text" class="form-control" spellcheck="false" name="searchProject" value=""
                 placeholder="{{'projectNavigation.label.search' | translate}}"
                 [ngModel]="model.searchText"
                 (keyup.enter)="performSearchProject(); searchProject.blur()"
                 #searchProject
                 data-testid="search-project-input">
          <button class="btn btn-primary btn-circle flex-shrink-0 flex-grow-0" (click)="performSearchProject()" data-testid="search-project-button">
            <app-svg-icon type="search" size="medium-small"/>
          </button>
          <span id="searchclear" class="mdi mdi-close" [hidden]="searchProject.value.length < 1"
                (click)="searchProject.value = ''; performSearchProject()" data-testid="search-project-clear"></span>
        </div>
      </div>
      <!-- /Suche -->
      <div class="wrapper-scroll-y" id="left-scroller" style="overflow-y: auto; height: 100%">
        <ng-scrollbar>
          <table class="folder-project-table m-0 table table-hover" data-testid="project-table">
            <tbody>
              @for(item of viewItems; track item.id) {
                @if(item.groupName) {
                  <tr (click)="selectProjectGroup(item)"
                    (dblclick)="item.groupType === PROJECT_FOLDER_TYPE ? '' : openProjectGroup(item)"
                    dbltap
                    (dblClicked)="item.groupType === PROJECT_FOLDER_TYPE ? '' : openProjectGroup(item)"
                    (dblTapped)="item.groupType === PROJECT_FOLDER_TYPE ? '' : openProjectGroup(item)"
                    [class.active]="model.currentSelectedItem && !!model.currentSelectedItem.groupName && item.id === model.currentSelectedItem.id">
                    <td class="folder-project-icon c-pointer" [class.project]="item.groupType === PROJECT_FOLDER_TYPE" (click)="collapse(item)">
                      <app-svg-icon [type]="getEntryIcon(item)" class="m-2 ms-1"/>
                    </td>
                    <td class="folder-project-name" (click)="collapse(item)">
                      <div [class.search-result]="isSearchedItem(item)">{{item.groupName}}</div>
                      @if (item.groupName === 'myAssignedProjects.groupName.label' && userID === item.userId) {
                        <span>{{ 'owner.myAssignedProjects.groupName.description' | translate }}</span>
                      }
                      @if(item.groupType === PROJECT_FOLDER_TYPE && item.options[0]?.value) {
                        <span>{{ item.options[0].value }}</span>
                      }
                    </td>
                  </tr>
                } @else if (item.name) {
                  <tr class="folder-project-terminals">
                    <td colspan="4">
                      <table width="100%">
                        <tbody>
                          <tr (click)="selectItem(item)" [class.active]="model.currentSelectedItem && !!model.currentSelectedItem.name && item.id === model.currentSelectedItem.id">
                            <td class="bg-transparent" width="8%" [style.max-width.px]="25"><app-svg-icon type="configuration" class="m-2 ms-4"/></td>
                            <td class="bg-transparent" width="37%" [class.search-result]="isSearchedItem(item)">{{item.name}}</td>
                            <td class="bg-transparent" width="30%">{{item.articleNumberLong?.reducedArticleNumberLong}}</td>
                            <td class="bg-transparent" width="20%">{{item.modificationDate | date:"dd.MM.yyyy - HH:mm"}}</td>
                            <td class="bg-transparent" width="5%" [style.max-width.px]="25">
                              <a (click)="openProjectVersionHistoryComponent(item)"
                                 tooltip
                                 [tooltipText]="'load.header.project_version_tooltip' | translate">
                                <app-svg-icon
                                  type="future"/>
                              </a>
                            </td>
                            <td class="bg-transparent" width="5%" [style.max-width.px]="25">
                              <i class="c-pointer mdi"
                                [ngClass]="getFinalizationStateIcon(item)"
                                (click)="openProjectVersionHistoryComponent(item)"
                                tooltip
                                [tooltipText]="getFinalizationStateTooltip(item)">
                              </i>
                            </td>
                          </tr>
                        <tbody>
                      </table>
                  </tr>
                }
              }
            </tbody>
          </table>
        </ng-scrollbar>
      </div>
    </div>
    <div class="dialog-panel panel-divider"></div>
    <div class="dialog-panel fluid d-flex flex-column overflow-scrolling-touch">
      <hr class="mt-0 w-100">
      <ol class="dialog-breadcrumb d-flex align-items-center">
        <li class="d-flex align-items-center"><app-svg-icon type="folder-user" size="medium-small"/>&nbsp;{{'shareProjectPopup.breadcrumb.permissions_for' | translate}}</li>
        @if(model?.currentSelectedItem?.name) {
          <li class="d-inline">
            @if (model.currentSelectedItem.projectGroup) {
              {{ model.currentSelectedItem.projectGroup.groupName }}
            }
          </li>
        }
        @if (model?.currentSelectedItem) {
          <li class="d-inline active">
            {{  model.currentSelectedItem.groupName || model.currentSelectedItem.name }}
          </li>
        }
      </ol>
      <!-- Suche -->
      <div class="dialog-search d-flex flex-shrink-0 flex-grow-0">
        <div class="btn-group flex-grow-1">
          <input type="text" class="form-control" spellcheck="false" name="searchUser" value=""
                 placeholder="{{'shareProjectPopup.placeholder.add_user' | translate}}"
                 inputRestricter="^[0-9a-zA-Z-_\/\\.@]*$"
                 (inputEvent)="searchUser.value = $event"
                 (keyup.enter)="performSearchUser()"
                 #searchUser
                 data-testid="search-user-input">
          <button class="btn btn-primary btn-circle flex-shrink-0 flex-grow-0" (click)="performSearchUser()" [disabled]="searchUser.value.length < 1" data-testid="search-user-button">
            <app-svg-icon type="plus" size="medium-small"/>
          </button>
          <span id="searchclear" class="mdi mdi-close" [hidden]="searchUser.value.length < 1" (click)="searchUser.value = ''"></span>
        </div>
      </div>
      <!-- /Suche -->
      <table class="table table-striped flex-grow-0 flex-shrink-0" fixedHeader [virtual]="true">
        <thead>
          <tr class="d-flex w-100">
            <th class="d-block flex-shrink-1 flex-grow-1" #headerFriendName>{{'shareProjectPopup.header.username_column' | translate}}</th>
            <th class="d-block flex-shrink-0 flex-grow-0" #headerFriendRead>{{'shareProjectPopup.header.read_right_column' | translate}}</th>
            <th class="d-block flex-shrink-0 flex-grow-0" #headerFriendEdit>{{'shareProjectPopup.header.edit_right_column' | translate}}</th>
            <th class="d-block" style="flex: 0 0 40px"></th>
            <th class="d-block" style="flex: 0 0 40px"></th>
          </tr>
        </thead>
      </table>
      <virtual-scroller #scroll class="flex-grow-1 friendlist" [items]="model.userFriends" [enableUnequalChildrenSizes]="true">
        <table class="table table-striped table-overflow-hidden fixed-layout" data-testid="user-table">
          <tbody class="new-stacking-context" #container>
            @for(friend of scroll.viewPortItems; track friend.id; let i = $index) {
              <tr>
                <td [attr.width]="headerFriendName.clientWidth" [class.disabled]="!friend.isReadable">{{friend.username}}</td>
                <td [attr.width]="headerFriendRead.clientWidth">
                  <div class="form-check" data-testid="user-read-checkbox">
                    <input class="form-check-input" type="checkbox" [id]="i + '_isReadable'"
                      [disabled]="!model.currentSelectedItem"
                      [(ngModel)]="friend.isReadable"
                      (change)="readCheckBoxChanged(friend)">
                    <label class="form-check-label" [for]="i + '_isReadable'"></label>
                  </div>
                </td>
                <td [attr.width]="headerFriendEdit.clientWidth">
                  <div class="form-check" data-testid="user-edit-checkbox">
                    <input class="form-check-input" type="checkbox" [id]="i + '_isEditable'"
                      [disabled]="!model.currentSelectedItem"
                      [(ngModel)]="friend.isEditable"
                      (change)="editCheckBoxChanged(friend)">
                    <label class="form-check-label" [for]="i + '_isEditable'"></label>
                  </div>
                </td>
                <td width="40px">
                  <a (click)="openModalPermissionsUserDialog(friend)"
                     tooltip tooltipPosition="bottom"
                     tooltipText="{{'shareProjectPopup.image.tooltip.show_user_shared_info' | translate}}">
                    <app-svg-icon type="information_circle" size="medium-small"/>
                  </a>
                </td>
                <td width="40px">
                  <a (click)="removeUserFromFriendList(friend)"
                     tooltip tooltipPosition="bottom"
                     tooltipText="{{'shareProjectPopup.remove.title.remove_user_from_friendList' | translate}}">
                    <app-svg-icon type="delete" size="medium-small"/>
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </virtual-scroller>
      <table class="table flex-grow-0 flex-shrink-0" fixedFooter [virtual]="true">
        <tfoot>
          <tr class="bg-white">
            <td [attr.width]="headerFriendName.clientWidth" class="text-end">
              {{'shareProjectPopup.label.select_all' | translate}}
            </td>
            <td [attr.width]="headerFriendRead.clientWidth">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="selectAllReadCheckBox"
                  [disabled]="!model.currentSelectedItem"
                  [(ngModel)]="model.selectAllReadCheckBox"
                  (change)="selectAllReadCheckBoxChanged()">
                <label class="form-check-label" for="selectAllReadCheckBox"></label>
              </div>
            </td>
            <td [attr.width]="headerFriendEdit.clientWidth">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="selectAllEditCheckBox"
                  [disabled]="!model.currentSelectedItem"
                  [(ngModel)]="model.selectAllEditCheckBox"
                  (change)="selectAllEditCheckBoxChanged()">
                <label class="form-check-label" for="selectAllEditCheckBox"></label>
              </div>
            </td>
            <td colspan="2" width="80px"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer flex-shrink-0">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()" data-testid="button-close">{{ 'global.label.close' | translate }}</button>
  <button type="button" class="btn btn-primary btn-forward" [disabled]="!model.submitEnabled" (click)="onConfirm()" data-testid="button-apply">{{ 'global.label.apply' | translate }}</button>
</div>
